/**
 * Format helpers for quantity values throughout the application.
 * These ensure consistent formatting of units and cases.
 */

/**
 * Formats a units quantity with thousand separators
 */
export function formatUnitsQuantity(value: number): string {
  if (value === 0) {
    return '-';
  }

  return value.toLocaleString('en-US');
}

/**
 * Formats a cases quantity with 1-2 decimal places and thousand separators
 */
export function formatCasesQuantity(value: number, caseQty: number): string {
  if (caseQty === 0) {
    return 'N/A';
  }

  if (value === 0) {
    return '-';
  }

  return (value / caseQty).toLocaleString('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  });
}

export function formatDoh(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return '—';
  }

  return Math.round(value).toLocaleString('en-US');
}

// Up to 2 decimals, trailing zeros stripped, then a `C` suffix. Never rounds
// up — fractional minimums are meaningful (they signal "applies at any
// quantity").
export function formatCases(cases: number): string {
  const formatted = cases.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return `${formatted}C`;
}
